import type { UUID } from '@appcues/domain-types';
import { createLifecycleFor } from 'ext/lib/collections';
import type { Locale } from './types';

export const TYPE = 'locales' as const;

export const {
  reject,
  resolve,
  send,
  create,
  append,
  flush,
  prune,
  remove,
  update,
  patterns,
} = createLifecycleFor<Locale>(TYPE);

export const SET_LOCALE = '@locales/SET_LOCALE' as const;

export interface SetLocaleAction {
  type: typeof SET_LOCALE;
  payload: { id: UUID; updateDirection?: boolean };
}

export const setLocale = (
  id: UUID,
  { updateDirection }: { updateDirection?: boolean } = {}
): SetLocaleAction => ({
  type: SET_LOCALE,
  payload: { id, updateDirection },
});

export const REMOVE_LOCALE = '@locales/REMOVE_LOCALE' as const;

export interface RemoveLocaleAction {
  type: typeof REMOVE_LOCALE;
  payload: { localeId: UUID };
}

export const removeLocale = (localeId: UUID): RemoveLocaleAction => ({
  type: REMOVE_LOCALE,
  payload: { localeId },
});

export const REMOVE_DRAFT_LOCALE = '@locales/REMOVE_DRAFT_LOCALE' as const;

export interface RemoveDraftLocaleAction {
  type: typeof REMOVE_DRAFT_LOCALE;
  payload: { id: UUID };
}

export const removeDraftLocale = (id: UUID): RemoveDraftLocaleAction => ({
  type: REMOVE_DRAFT_LOCALE,
  payload: { id },
});

export const CLEAR_DRAFT_LOCALES = '@locales/CLEAR_DRAFT_LOCALES' as const;

export interface ClearDraftLocalesAction {
  type: typeof CLEAR_DRAFT_LOCALES;
}

export const clearDraftLocales = (): ClearDraftLocalesAction => ({
  type: CLEAR_DRAFT_LOCALES,
});

export const UPDATE_TRANSLATION = '@locales/UPDATE_TRANSLATION' as const;

export interface UpdateTranslationAction {
  type: typeof UPDATE_TRANSLATION;
  payload: any;
}

export const updateTranslation = (payload: any): UpdateTranslationAction => ({
  type: UPDATE_TRANSLATION,
  payload,
});

export const AUTO_TRANSLATE = '@locales/AUTO_TRANSLATE' as const;

export interface AutoTranslateAction {
  type: typeof AUTO_TRANSLATE;
  payload: any;
}

export const autoTranslate = (payload: any): AutoTranslateAction => ({
  type: AUTO_TRANSLATE,
  payload,
});
